import { BaseWidgetEditorComponent } from '@juvare/widget-ui/BaseWidgetEditorComponent';
import SquareIcon from '@mui/icons-material/Square';
import { Alert, Box, Paper, Typography } from '@mui/material';
import React from 'react';
import { useCommonFormUiTranslation } from '../hooks';
import { buildGeneralTab, buildHiddenTab, buildStyleTab, showWidgetEditDialog } from '../WidgetEditDialog';
import { defaultWidgetLabelProvider, handleWidgetUpdate, makeNewConfigUnique } from '../WidgetForm/Utils';
import { WidgetHandler } from '../WidgetHandler';
import { type } from './types';
const WidgetFormTableView = (props) => {
    const handler = new WidgetHandler(props).select(props.config.component);
    const { t } = useCommonFormUiTranslation();
    if (handler) {
        const pairs = handler.getLabelValueAsTextPairs();
        return (React.createElement(Box, { component: 'dl', sx: {
                marginBlockStart: 0,
                marginBlockEnd: 0,
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                justifyContent: 'stretch',
                alignItems: 'stretch',
                py: 2,
            } }, pairs.map(({ label, text }, index) => (React.createElement(React.Fragment, { key: index },
            React.createElement(Box, { component: 'dt', sx: {
                    display: 'flex',
                    alignItems: 'center',
                    p: 2,
                    borderBottom: (theme) => '1px solid ' + theme.palette.divider,
                    '&:first-of-type': { pt: 0 },
                    '&:last-of-type': { pb: 0, borderBottom: 'none' },
                } },
                React.createElement(Typography, { variant: 'body2' }, label)),
            React.createElement(Box, { component: 'dd', sx: {
                    marginInlineStart: 0,
                    p: 2,
                    borderBottom: (theme) => '1px solid ' + theme.palette.divider,
                    '&:first-of-type': { pt: 0 },
                    '&:last-of-type': { pb: 0, borderBottom: 'none' },
                } },
                React.createElement(Typography, { variant: 'subtitle2' }, text)))))));
    }
    else if (props.editMode) {
        return (React.createElement(Alert, { severity: 'error' },
            t('widget.widgetForm.componentNotFound'),
            ": ",
            props.config.component));
    }
    else {
        return null;
    }
};
const WidgetFormTableViewEditor = (props) => {
    const { t } = useCommonFormUiTranslation();
    return (React.createElement(BaseWidgetEditorComponent, Object.assign({}, props, { widgetLabelProvider: defaultWidgetLabelProvider, onEditWidget: (endEditing) => showWidgetEditDialog(props, endEditing, {
            title: t('widget.widgetSelect.labelValuePairs'),
        }, buildGeneralTab(props, {
            children: [
                {
                    type: 'form.text',
                    key: 'component',
                    label: t('widget.widgetForm.component'),
                    validate: {
                        required: true,
                        custom: (value) => {
                            if (value && !new WidgetHandler(props).select(value)) {
                                return t('widget.widgetForm.componentNotFound');
                            }
                            return undefined;
                        },
                    },
                },
            ],
        }), buildHiddenTab(props, { t }), buildStyleTab(props)) }),
        React.createElement(Paper, { variant: 'outlined', sx: { p: 2 } },
            React.createElement(Typography, null,
                t('widget.widgetSelect.labelValuePairs'),
                ": ",
                props.config.component))));
};
export const widgetFormTableView = {
    type,
    update: (props) => {
        // need to always rerender because some data could have changed
        props.update();
        return handleWidgetUpdate(props);
    },
    component: WidgetFormTableView,
    icon: React.createElement(SquareIcon, { fontSize: 'small' }),
    editorComponent: WidgetFormTableViewEditor,
    createWidget: (rootConfig, editorPath, widgets) => makeNewConfigUnique(rootConfig, editorPath, widgets, { type, component: '^' }),
};
